import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, MapPin, Clock } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Ana Sayfa', href: '#home' },
    { name: 'Menü', href: '#menu' },
    { name: 'Hakkımızda', href: '#about' },
    { name: 'Galeri', href: '#gallery' },
    { name: 'İletişim', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      {/* Top Bar */}
      <div className="bg-[#722F37] text-white py-2 px-4 hidden md:block">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-sm">
          <div className="flex items-center gap-6">
            <a href={`tel:${restaurantInfo.phone1.replace(/\s/g, '')}`} className="flex items-center gap-2 hover:opacity-80">
              <Phone size={14} />
              <span>{restaurantInfo.phone1}</span>
            </a>
            <a href={`tel:${restaurantInfo.phone2.replace(/\s/g, '')}`} className="flex items-center gap-2 hover:opacity-80">
              <Phone size={14} />
              <span>{restaurantInfo.phone2}</span>
            </a>
          </div>
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-2">
              <Clock size={14} />
              <span>{restaurantInfo.hours}</span>
            </span>
            <span className="flex items-center gap-2">
              <MapPin size={14} />
              <span>Esenler / İstanbul</span>
            </span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header 
        className={`sticky top-0 z-50 transition-all duration-300 ${
          isScrolled 
            ? 'bg-[#fffef2]/95 backdrop-blur-sm shadow-sm' 
            : 'bg-[#fffef2]'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <a href="#home" onClick={() => scrollToSection('#home')} className="flex-shrink-0">
              <img 
                src={restaurantInfo.logo} 
                alt="Kosovalı Döner - 1990" 
                className="h-14 md:h-16 w-auto"
                style={{ 
                  imageRendering: 'auto',
                  WebkitFontSmoothing: 'antialiased',
                  filter: 'none'
                }}
              />
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="text-[#333333] text-sm font-medium relative group py-2"
                >
                  {link.name}
                  <span className="absolute bottom-0 left-0 w-0 h-[1px] bg-[#722F37] transition-all duration-500 group-hover:w-full" />
                </button>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden lg:flex items-center gap-4">
              <a
                href={`https://wa.me/${restaurantInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-transparent border border-[#722F37] text-[#722F37] px-6 py-3 text-sm font-semibold hover:bg-[#722F37] hover:text-white transition-all duration-200"
              >
                Sipariş Ver
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 text-[#333333]"
              aria-label="Menü"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#fffef2] border-t border-[#bcbbb4]">
            <div className="px-4 py-4 space-y-3">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="block w-full text-left text-[#333333] py-3 text-base font-medium border-b border-[#ebeade]"
                >
                  {link.name}
                </button>
              ))}
              <div className="pt-4 space-y-3">
                <a
                  href={`tel:${restaurantInfo.phone1.replace(/\s/g, '')}`}
                  className="flex items-center gap-3 text-[#722F37] py-2"
                >
                  <Phone size={18} />
                  <span>{restaurantInfo.phone1}</span>
                </a>
                <a
                  href={`https://wa.me/${restaurantInfo.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-[#722F37] text-white text-center py-3 font-semibold"
                >
                  WhatsApp ile Sipariş Ver
                </a>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;